module.exports = __webpack_public_path__ + "img/IIFH_h_wm_white.27b4c9c2.png";